<h1 class="preview-header" mat-dialog-title>
  Preview
  <button (click)="close()" class="close-btn" isIconButton="true" mat-button>
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</h1>
<div class="preview-content flex flex-col" mat-dialog-content>
  <section class="flex flex-col flex-start-stretch gap-12">
    @if (pdfBlob) {
      <ng2-pdfjs-viewer
        [viewerId]="viewerId"
        [downloadFileName]="downloadFileName"
        [openFile]="false"
        [pdfSrc]="pdfBlob"
        [viewBookmark]="false"
        theme="dark"
        class="print-preview-dialog-iframe"
        [urlValidation]="false"
      ></ng2-pdfjs-viewer>
    }
  </section>
</div>
